import type { FC, ReactNode } from 'react'
import { cn } from '@/helpers/utils'

interface SubmissionFormFooterProps {
	children: ReactNode
	className?: string
}

export const SubmissionFormFooter: FC<SubmissionFormFooterProps> = ({
	children,
	className
}) => {
	return (
		<footer
			className={cn(
				'sticky bottom-0 bg-neutral-white m:bg-neutral-50 px-6 m:py-4 pt-12 pb-8',
				className
			)}
		>
			{children}
		</footer>
	)
}
